import { render, staticRenderFns } from "./noticesMore.vue?vue&type=template&id=6a6ade97&scoped=true&"
import script from "./noticesMore.vue?vue&type=script&lang=js&"
export * from "./noticesMore.vue?vue&type=script&lang=js&"
import style0 from "./noticesMore.vue?vue&type=style&index=0&id=6a6ade97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6ade97",
  null
  
)

export default component.exports